import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { ImageToVideoSection, CommunityGallerySection, PiecanNotice } from '@/components/features'
import { CharacterHomeCTA } from '@/components/features/characters'
import { trackPageView } from '@/services/analytics'

export function HomePage() {
  const { user, isSignedIn } = useUser()

  useEffect(() => {
    trackPageView('Home', 'Home', user?.id, { is_logged_in: !!isSignedIn })
  }, [user?.id, isSignedIn])

  return (
    <div className="py-12 space-y-16">
      {/* Hero + Image-to-Video */}
      <div className="flex flex-col items-center px-8 max-w-5xl mx-auto">
        <Hero />
        <div className="w-full max-w-2xl mt-10">
          <ImageToVideoSection />
        </div>

        {/* Partner upsell — sits above the Characters CTA so upload-capable
            users see the "try PieCan for uploads" nudge before scrolling into
            the gallery. Renders nothing for users where can_upload_images
            is false, so signed-out and gated users see no change here. */}
        <div className="w-full mt-8">
          <PiecanNotice source="home_notice" />
        </div>

        {/* Characters nudge — sits between the top input and the
            community gallery so users discover the characters flow
            without having to find the sidebar entry. */}
        <div className="w-full mt-8">
          <CharacterHomeCTA />
        </div>
      </div>

      {/* Community Gallery - 80% of viewport width */}
      <div className="w-[80%] mx-auto">
        <CommunityGallerySection />
      </div>
    </div>
  )
}

function Hero() {
  return (
    <div className="text-center max-w-2xl">
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">
        Bring Your Ideas to Life
      </h1>
      <p className="mt-4 text-base sm:text-lg text-[#888]">
        Describe the motion and watch the magic happen.
      </p>
    </div>
  )
}
